import HeaderPage from '../../Components/Header/Header'
import { Border, MainBody } from '../Main/Main-Styled'
import adSportEx from '../../images/adSportEx.png'
import publico from '../../images/publico.png'
import layout from '../../images/layout.png'
import tabler from '../../images/tabler.png'
import inter from '../../images/interface.png'
import styleGuideDesktop from '../../images/styleGuide.png'
import styleGuideMobile from '../../images/styleGuideMobile.png'
import propostaDesktop from '../../images/proposta.png'
import propostaMobile from '../../images/propostaMobile.svg'
import {
  ContainerDesc,
  ContainerStyled,
  ContainerStyledImgs,
  PropostaStyled
} from './Projeto5-Styled'
import FooterPage from '../../Components/Footer/Footer'
function Projeto5() {
  return (
    <>
      <HeaderPage />

      <MainBody>
        <ContainerStyled>
          <div>
            <h1>AdSports</h1>
            <h2>Resumo</h2>

            <p>
              Plataforma que conecta atletas, entidades esportivas e marcas
              interessadas em oportunidades de patrocínio.
            </p>
            <span>
              Empresa: <p>TGID (Transform and grow in digital)</p>
            </span>
            <span>
              Participantes:
              <p>
                Lygia Magalhães (UX/UI Designer) e Daniel Rezende (Lead Product
                Designer)
              </p>
            </span>
            <div className="mobileEx">
              <img src={adSportEx} alt="" />
            </div>
          </div>

          <div className="desktopEx">
            <img src={adSportEx} alt="" />
          </div>
        </ContainerStyled>
        <ContainerDesc>
          <h2>O contexto</h2>

          <p>
            O AdSports foi desenvolvido para conectar dois perfis:
            atletas/entidades esportivas e marcas patrocinadoras.
          </p>
          <p>
            O desafio do projeto era criar uma experiência única que atendesse
            necessidades diferentes, sem gerar confusão na navegação ou
            inconsistência na interface. Além disso, o produto precisava evoluir
            com escalabilidade, já que novas funcionalidades seriam adicionadas
            ao longo do tempo.
          </p>
        </ContainerDesc>
        <ContainerDesc>
          <div className="processo">
            <h2 className="sectName">Processo</h2>

            <ul>
              <li>
                <div className="process">
                  <img src={inter} alt="icone de interface" />
                  <p>
                    Estruturação das jornadas e wireframes de entidades e
                    marcas.
                  </p>
                </div>
              </li>

              <li>
                <div className="process">
                  <img src={tabler} alt="icone de tabler" />
                  <p>
                    Padronização de componentes para escalabilidade do produto.
                  </p>
                </div>
              </li>

              <li>
                <div className="process">
                  <img src={layout} alt="icone de layout" />
                  <p>Refinamento de interfaces consistentes e responsivas.</p>
                </div>
              </li>

              <li>
                <div className="process">
                  <img src={publico} alt="icone de duas silhuetas padrões" />
                  <p>Alinhamento contínuo com produto e desenvolvimento.</p>
                </div>
              </li>
            </ul>
          </div>
        </ContainerDesc>

        <ContainerDesc>
          <h2>Style Guide</h2>
          <ContainerStyledImgs>
            <div>
              <picture>
                <source media="(max-width: 1024px)" srcSet={styleGuideMobile} />
                <img src={styleGuideDesktop} alt="Style Guide" />
              </picture>
            </div>
          </ContainerStyledImgs>
        </ContainerDesc>
        <ContainerDesc>
          <h2>A proposta</h2>

          <p>
            O AdSports foi lançado e segue em evolução contínua, guiado por
            dados de uso e feedback contínuo dos usuários.
          </p>
          <p className="p-ul">
            A estrutura de design system e os fluxos desenvolvidos contribuíram
            para:
            <ul>
              <li>Maior consistência visual do produto</li>
              <li>Redução de retrabalho entre design e desenvolvimento</li>
              <li>Base mais escalável para novas funcionalidades</li>
            </ul>
          </p>

          <div>
            <a
              className="LinkExterno"
              target="_blank"
              rel="noopener noreferrer"
              href="https://adsports.com.br/"
            >
              Link para a AdSports.
            </a>

            <PropostaStyled>
              <picture>
                <source media="(max-width: 1024px)" srcSet={propostaMobile} />
                <img src={propostaDesktop} alt="Proposta do projeto AdSports" />
              </picture>
            </PropostaStyled>
          </div>
        </ContainerDesc>
      </MainBody>
      <Border style={{ marginTop: '64px' }} />
      <FooterPage />
    </>
  )
}

export default Projeto5
